app.directive("fdCarousel", function ($sce, $compile) {
    return {
        restrict: 'EA',
        replace: true,
        scope: {
            title: '=Carousel',
            ngModel: '='
        },
        compile: function compile(tElement, tAttributes) {
            return {
                pre: function preLink(scope, element, iAttrs, controller) {
                    scope.initialWidth = element.outerWidth(true);
                    var controlTpl = '<button type="button" class="fd-carousel-prev" ng-click="prevSlide()"><span class="txt">Prev</span></button>' +
                      '<button type="button" class="fd-carousel-next" ng-click="nextSlide()"><span class="txt">Next</span><span></button>';
                    var compiled = $compile(controlTpl)(scope);
                    element.after(compiled);
                },
                post: function postLink(scope, element, iAttrs, controller) {
                    element.attr('currentIndex', 0);
                    var activeIndex = 0;
                    setTimeout(function () {
                        element.find('.fd-carousel-slide').eq(activeIndex).addClass('active');
                    }, 150);
                    scope.prevSlide = function prevSlide() {
                        activeIndex = parseInt(element.attr('currentIndex'));
                        var newIndex = activeIndex > 0 ? activeIndex - 1 : (scope.ngModel.length - 1);
                        if (activeIndex != newIndex) {
                            scope.$emit('want-to-change', { index: newIndex });
                            scope.$emit('want-to-change-click', { index: newIndex });
                        }
                    };
                    scope.nextSlide = function nextSlide() {
                        activeIndex = parseInt(element.attr('currentIndex'));
                        var newIndex = (activeIndex + scope.ngModel.length + 1) % scope.ngModel.length;
                        if (activeIndex != newIndex) {
                            scope.$emit('want-to-change', { index: newIndex });
                            scope.$emit('want-to-change-click', { index: newIndex });
                        }
                    };
                    scope.animateSlider = function animateSlider(index, direction) {
                        // delay = delay ? delay : 0;
                        var currentElt = element.find('.fd-carousel-slide').eq(element.attr('currentIndex')).addClass('left');
                        switch (direction) {
                            case -1:
                                var prevElt = null;
                                prevElt = element.find('.fd-carousel-slide').eq(index).addClass('prev');
                                prevElt = element.find('.fd-carousel-slide').eq(index).addClass('right');
                                currentElt.removeClass('active right');
                                prevElt.removeClass('prev right').addClass('active');
                                /* setTimeout(function () {
                                 prevElt = element.find('.fd-carousel-slide').eq(index).addClass('prev');
                                 }, 50 + delay);
                                 setTimeout(function () {
                                 prevElt = element.find('.fd-carousel-slide').eq(index).addClass('right');
                                 }, 100 + delay);
                                 setTimeout(function () {
                                 currentElt.removeClass('active right');
                                 prevElt.removeClass('prev right').addClass('active');
                                 }, 600 + delay); */
                                break;
                            case 1:
                                var nextElt = null;
                                nextElt = element.find('.fd-carousel-slide').eq(index).addClass('next');
                                nextElt = element.find('.fd-carousel-slide').eq(index).addClass('left');
                                currentElt.removeClass('active left');
                                nextElt.removeClass('next left').addClass('active');
                                /* setTimeout(function () {
                                 nextElt = element.find('.fd-carousel-slide').eq(index).addClass('next');
                                 }, 50 + delay);
                                 setTimeout(function () {
                                 nextElt = element.find('.fd-carousel-slide').eq(index).addClass('left');
                                 }, 100 + delay);
                                 setTimeout(function () {
                                 currentElt.removeClass('active left');
                                 nextElt.removeClass('next left').addClass('active');
                                 }, 600 + delay); */
                                break;
                            default:
                                break;
                        }
                        activeIndex = index;
                        element.attr('currentIndex', index);
                    };
                    scope.$on('need-to-chage', function (event, data) {
                        scope.animateSlider(data.index, +1);
                    });
                }
            }
        }
    };
});